import type { ComponentProps } from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { LOST_REASONS, type LostReason } from '../constants';

type LostReasonSelectProps = {
  value: LostReason | '';
  onChange: (value: LostReason) => void;
} & Omit<ComponentProps<typeof SelectTrigger>, 'value' | 'onChange'>;

/** The lost-reason picker (ADR-108) — shared by the board's Lost dialog, the
 *  deal form and proposal rejection. Extra props (id, aria-*) go to the
 *  trigger, so it works inside `FormControl`. */
export function LostReasonSelect({ value, onChange, ...triggerProps }: LostReasonSelectProps) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as LostReason)}>
      <SelectTrigger className="w-full" {...triggerProps}>
        <SelectValue placeholder="Pick a reason" />
      </SelectTrigger>
      <SelectContent>
        {LOST_REASONS.map((r) => (
          <SelectItem key={r.value} value={r.value}>
            {r.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
